import { useLayoutEffect, useState } from "react";

// Si el popover no cabe debajo del formulario (viewport), lo abre hacia arriba —
// pero solo si arriba sí cabe completo; si ningún lado cabe, se queda abajo
// (el usuario puede hacer scroll hacia abajo para revelarlo).
export function usePopoverFlip(ref) {
    const [flip, setFlip] = useState(false);
    useLayoutEffect(() => {
        const el = ref.current;
        if (!el) return;
        const anchor = el.offsetParent;
        const rect = anchor ? anchor.getBoundingClientRect() : null;
        const below = rect ? window.innerHeight - rect.bottom : window.innerHeight;
        const above = rect ? rect.top : 0;
        const need = el.offsetHeight + 12;
        setFlip(need > below && above >= need);
    }, [ref]);
    return flip;
}
